import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDataFromUserAttributes } from "services/common";
import { Dropdown, Divider, Button } from "semantic-ui-react";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { useTranslation } from "react-i18next";
import { addUserToCognitoGroup, removeUserFromCognitoGroup } from "services/apiMiddleware";

const UserGroupEdition = ({ user, setIsUserEditing }) => {
  const userGroups = useSelector((state) => state.userGroups.items);
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [confirmationModalData, setConfirmationModalData] = useState({
    text: "",
    headerText: "",
    icon: "",
  });
  const originalUserData = {
    groupname: user.userGroup,
    username: user?.id,
    userpoolid: userGroups[0]?.UserPoolId,
    UserEmail: user.email,
  };

  const [currentUserData, setCurrentUserData] = useState({
    groupname: originalUserData?.groupname,
    username: originalUserData?.username,
    userpoolid: userGroups[0]?.UserPoolId,
    UserEmail: user.email,
    UserOriginalGroupName: originalUserData.userGroup,
  });

  const handleChange = ({ innerText }) => {
    setCurrentUserData((prevCurrentUserData) => ({
      ...prevCurrentUserData,
      groupname: innerText,
    }));

    innerText === originalUserData.groupname
      ? setIsButtonDisabled(true)
      : setIsButtonDisabled(false);
  };

  const dropDownOptions = userGroups?.map(({ GroupName }) => ({
    key: GroupName,
    text: GroupName.charAt(0) + GroupName.slice(1),
    value: GroupName,
  }));

  const handleOpenConfirmationModal = () => {
    const userFullName = `
      ${getDataFromUserAttributes(user.email)}
    `;
    setIsConfirmationModalOpen(true);
    setConfirmationModalData({
      text: (
        <>
          <p>{t("update_user_modal_text", { userFullName })}</p>
          <p>
            {t("update_user_from_group", {
              originGroup: originalUserData?.groupname,
              destinationGroup: currentUserData.groupname,
            })}
          </p>
        </>
      ),
      headerText: t("update_user_modal_header"),
      icon: "exchange",
    });
  };
  const handleUpdateUserGroup = async () => {
    dispatch.users.setLoading(true);
    const isUserAddedToGroup = await addUserToCognitoGroup(currentUserData);
    originalUserData.isUpdatingUser = true;
    isUserAddedToGroup &&
      originalUserData.groupname !== "None" &&
      (await removeUserFromCognitoGroup(originalUserData));
    dispatch.users.init();
    setIsUserEditing(false);
  };

  return (
    <>
      <Divider />
      <h3>{t("edit_user_group")}:</h3>
      <div style={{ display: "flex", gap: "1rem", alignItems: "baseline" }}>
        <div>
          {" "}
          {t("update_user_field", {
            userEmail: user.email,
            actualUserGroup: getDataFromUserAttributes(user.userGroup),
          })}
        </div>
        <Dropdown
          options={dropDownOptions}
          defaultValue={originalUserData?.groupname}
          selection
          onChange={(e) => handleChange(e.target)}
        />
        <Button
          style={{
            backgroundColor: "#4700a3",
            color: "white",
          }}
          disabled={isButtonDisabled}
          onClick={() => handleOpenConfirmationModal()}
        >
          {t("update")}
        </Button>
        <Button basic onClick={() => setIsUserEditing(false)}>
          {t("cancel")}
        </Button>
      </div>
      <Divider />
      <ConfirmationModal
        data={confirmationModalData}
        open={isConfirmationModalOpen}
        setOpen={setIsConfirmationModalOpen}
        onSuccess={() => handleUpdateUserGroup(currentUserData, originalUserData)}
        dataForOnSuccess={{}}
        onCancel={() =>
          setConfirmationModalData({
            text: "",
            headerText: "",
            icon: "",
          })
        }
      />
    </>
  );
};
export default UserGroupEdition;
